export const SET_BOOKMARKS_LOADED = "SET_BOOKMARKS_LOADED";

export const setBookmarksLoaded = (bookmarksLoaded: boolean) => {
  return {
    bookmarksLoaded,
    type: SET_BOOKMARKS_LOADED
  };
};
